
'use client';
import React, { FC, useEffect } from 'react'
import house from '../../images/icons/house.png'
import car1 from '../../images/icons/car1.png'
import credit from '../../images/icons/credit.png'
import home_master from '../../images/icons/home_master.png'
import car_master from '../../images/icons/car_master.png'
import home_material from '../../images/icons/home_material.png'
import car_material from '../../images/icons/car_material.png'
import { motion } from "framer-motion"
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ImageBox from '../../components/ImageBox';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/Store';


function Selectors() {
     const {t}=useTranslation()

     const [searchParams, setSearchParams] = useSearchParams();
     const big_category = Number(searchParams.get('big_category'))
     const category = Number(searchParams.get('category'))
     const router = useNavigate()
     const {house_type_data, credit_type_data, ctype_data, house_product_type_data, car_product_type_data, car_service_types_data, house_service_types_data}=useStore()
    useEffect(()=>{
        if(isNaN(big_category) || big_category>2 || big_category<=0 || isNaN(category) || category>8 || category<=0){
          router('/')
        }
    }, [big_category, router])
  return (
     <div  className='big_box'>
         <div className='sel_selector_box'>
            {category===1?house_type_data.map((item, key)=>{
                 return( <motion.div className='selectors_div_box' initial={{y:100, opacity:0}}  animate={{ y: 0, opacity:1 }}
    transition={{ ease: "easeOut", duration: 0.5 }}><Link to={`/products?big_category=1&category=${category}&house_type__in=[${item.id}]`} className='sel_selector_card' key={key}>{item[`name_${t("lang")==='ru'?'ru':'uz'}`]}</Link></motion.div>)
            }):category===2?house_service_types_data.map((item, key)=>{
                return( <motion.div className='selectors_div_box' initial={{y:100, opacity:0}}  animate={{ y: 0, opacity:1 }}
    transition={{ ease: "easeOut", duration: 0.5 }}><Link to={`/products?big_category=1&category=${category}&service_types__in=[${item.id}]`} className='sel_selector_card' key={key}>{item[`name_${t("lang")==='ru'?'ru':'uz'}`]}</Link></motion.div>)
           }):category===3?house_product_type_data.map((item, key)=>{
            return( <motion.div className='selectors_div_box' initial={{y:100, opacity:0}}  animate={{ y: 0, opacity:1 }}
    transition={{ ease: "easeOut", duration: 0.5 }}><Link to={`/products?big_category=1&category=${category}&product_type__in=${item.id}`} className='sel_selector_card' key={key}>{item[`name_${t("lang")==='ru'?'ru':'uz'}`]}</Link></motion.div>)
       }):category===4?credit_type_data.map((item, key)=>{
        return( <motion.div className='selectors_div_box' initial={{y:100, opacity:0}}  animate={{ y: 0, opacity:1 }}
    transition={{ ease: "easeOut", duration: 0.5 }}><Link to={`/products?big_category=1&category=${category}&itype__in=[${item.id}]`} className='sel_selector_card' key={key}>{item[`name_${t("lang")==='ru'?'ru':'uz'}`]}</Link></motion.div>)
   }):category===5?ctype_data.map((item, key)=>{
    return( <motion.div className='selectors_div_box' initial={{y:100, opacity:0}}  animate={{ y: 0, opacity:1 }}
    transition={{ ease: "easeOut", duration: 0.5 }}><Link to={`/products?big_category=2&category=${category}&ctype=${item.id}`} className='sel_selector_card' key={key}>{item[`name_${t("lang")==='ru'?'ru':'uz'}`]}</Link></motion.div>)
}):category===6?car_service_types_data.map((item, key)=>{
    return( <motion.div className='selectors_div_box' initial={{y:100, opacity:0}}  animate={{ y: 0, opacity:1 }}
    transition={{ ease: "easeOut", duration: 0.5 }}><Link to={`/products?big_category=2&category=${category}&service_types__in=[${item.id}]`} className='sel_selector_card' key={key}>{item[`name_${t("lang")==='ru'?'ru':'uz'}`]}</Link></motion.div>)
}):category===7?car_product_type_data.map((item, key)=>{
    return( <motion.div className='selectors_div_box' initial={{y:100, opacity:0}}  animate={{ y: 0, opacity:1 }}
    transition={{ ease: "easeOut", duration: 0.5 }}><Link to={`/products?big_category=2&category=${category}&product_type__in=${item.id}`} className='sel_selector_card' key={key}>{item[`name_${t("lang")==='ru'?'ru':'uz'}`]}</Link></motion.div>)
}):category===8?credit_type_data.map((item, key)=>{
    return( <motion.div className='selectors_div_box' initial={{y:100, opacity:0}}  animate={{ y: 0, opacity:1 }}
    transition={{ ease: "easeOut", duration: 0.5 }}><Link to={`/products?big_category=2&category=${category}&itype__in=[${item.id}]`} className='sel_selector_card' key={key}>{item[`name_${t("lang")==='ru'?'ru':'uz'}`]}</Link></motion.div>)
}):<></>}
         </div>
 
  </div>
 
  )
}
export default Selectors
